import { Outlet, useNavigate } from "react-router-dom";
import { useGetSquareAuthStatus } from "../../../../hooks/api/queries/useSquareup";
import LoaderHelper from "../../LoaderHelper/LoaderHelper";
import { pathConstants } from "../../../../routes/pathContants";
import { useEffect } from "react";

export const SquareAppGuard = () => {
  const navigate = useNavigate();
  const { data: squareValidity, isLoading: isLoadingStatus } =
    useGetSquareAuthStatus();

  useEffect(() => {
    if (!squareValidity?.is_active) {
      navigate(pathConstants.APPS_SQUAREUP);
    }
  }, [squareValidity, navigate]);

  return (
    <LoaderHelper isLoading={isLoadingStatus} classNames={"mt-5"}>
      <Outlet />
    </LoaderHelper>
  );
};
